import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  data: []
};

const uploadAddressHistorySlice = createSlice({
  name: 'uploadAddressHistory',
  initialState,
  reducers: {
    setUploadAddressHistory(state, action) {
      state.data = action.payload;
    }
  }
});

export const { setUploadAddressHistory } = uploadAddressHistorySlice.actions;

export default uploadAddressHistorySlice.reducer;
